export const ADD_POMPE_REQUEST = "ADD_POMPE_REQUEST";
export const ADD_POMPE_SUCCESS = "ADD_POMPE_SUCCESS";
export const ADD_POMPE_FAIL = "ADD_POMPE_FAIL";

export const UPDATE_POMPE_REQUEST = "UPDATE_POMPE_REQUEST";
export const UPDATE_POMPE_SUCCESS = "UPDATE_POMPE_SUCCESS";
export const UPDATE_POMPE_FAIL = "UPDATE_POMPE_FAIL";

export const DELETE_POMPE_REQUEST = "DELETE_POMPE_REQUEST";
export const DELETE_POMPE_SUCCESS = "DELETE_POMPE_SUCCESS";
export const DELETE_POMPE_FAIL = "DELETE_POMPE_FAIL";
